module.exports = __webpack_public_path__ + "img/qrcode3.eda21776.jpg";